import { MessageCircle, BookOpen, Users, Sparkles, Activity, Target, Check, Minus, X } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const isVideo = (u) => /\.(mp4|mov|webm|avi|m4v)$/i.test(u || "");

export const mediaSrc = (u) => {
  if (!u) return u;
  if (u.startsWith("http")) return u;
  const token = localStorage.getItem("renka_token");
  const sep = u.includes("?") ? "&" : "?";
  return `${BACKEND}${u}${token ? `${sep}auth=${token}` : ""}`;
};

// Area visual identity (matches mobile mockups)
export const AREA_META = {
  "Dil ve İletişim": { icon: MessageCircle, hex: "#7C3AED", bg: "bg-violet-50", fg: "text-violet-600", pct: "text-violet-600" },
  "Akademik Beceriler": { icon: BookOpen, hex: "#0EA5E9", bg: "bg-sky-50", fg: "text-sky-600", pct: "text-sky-600" },
  "Sosyal Beceriler": { icon: Users, hex: "#22C55E", bg: "bg-emerald-50", fg: "text-emerald-600", pct: "text-emerald-600" },
  "Öz Bakım Becerileri": { icon: Sparkles, hex: "#F59E0B", bg: "bg-amber-50", fg: "text-amber-600", pct: "text-amber-600" },
  "Motor Beceriler": { icon: Activity, hex: "#EF4444", bg: "bg-red-50", fg: "text-red-600", pct: "text-red-600" },
};
const AREA_ALIAS = {
  "Akademik": "Akademik Beceriler",
  "Öz Bakım": "Öz Bakım Becerileri",
  "İletişim": "Dil ve İletişim",
};
const EXTRA_AREA = {
  "Dikkat": { icon: Target, hex: "#6366F1", bg: "bg-indigo-50", fg: "text-indigo-600", pct: "text-indigo-600" },
  "Davranış": { icon: Sparkles, hex: "#EC4899", bg: "bg-pink-50", fg: "text-pink-600", pct: "text-pink-600" },
  "Yürütücü İşlev": { icon: Target, hex: "#14B8A6", bg: "bg-teal-50", fg: "text-teal-600", pct: "text-teal-600" },
};
export const getArea = (name) =>
  AREA_META[name] || AREA_META[AREA_ALIAS[name]] || EXTRA_AREA[name] ||
  { icon: Target, hex: "#7C3AED", bg: "bg-violet-50", fg: "text-violet-600", pct: "text-violet-600" };

export function TaskCategoryLabel({ name, className = "" }) {
  if (!name) return null;
  const { hex } = getArea(name);
  return (
    <span
      className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${className}`}
      style={{ backgroundColor: `${hex}1a`, color: hex }}
    >
      {name}
    </span>
  );
}

export const DAILY = {
  done: { label: "Yapıldı", chip: "bg-emerald-100 text-emerald-700", solid: "bg-emerald-500 text-white", ring: "border-emerald-200", dot: "bg-emerald-500", iconText: "text-emerald-600", Icon: Check },
  partial: { label: "Kısmen Yapıldı", chip: "bg-amber-100 text-amber-700", solid: "bg-amber-500 text-white", ring: "border-amber-200", dot: "bg-amber-500", iconText: "text-amber-600", Icon: Minus },
  missed: { label: "Yapılamadı", chip: "bg-red-100 text-red-700", solid: "bg-red-500 text-white", ring: "border-red-200", dot: "bg-red-500", iconText: "text-red-600", Icon: X },
};

const TR_FULL = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export function formatTRDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return `${d.getDate()} ${TR_FULL[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDMY(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
}

export function ageString(birth) {
  if (!birth) return "—";
  const b = new Date(birth);
  if (isNaN(b)) return "—";
  const now = new Date();
  let months = (now.getFullYear() - b.getFullYear()) * 12 + (now.getMonth() - b.getMonth());
  if (now.getDate() < b.getDate()) months -= 1;
  if (months < 0) months = 0;
  const y = Math.floor(months / 12);
  const m = months % 12;
  return `${y} Yaş ${m} Ay`;
}

export const todayISO = () => new Date().toISOString().slice(0, 10);
